console.log("product-form.js loaded");

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) {
          console.error("Product form element not found!");
          return;
        }

        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
          console.error("Submit button not found in product form!");
          return;
        }

        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer") && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Remove font input fields if corresponding engraving line is empty
        for (let i = 1; i <= 8; i++) {
          const lineInput = this.form.querySelector(
            `[name="properties[Engraving Line ${i}]"]`
          );
          const fontInput = this.form.querySelector(
            `[name="properties[Engraving Font ${i}]"]`
          );
          if (lineInput && fontInput && !lineInput.value.trim()) {
            console.log("Removing font input for line", i);
            fontInput.parentNode.removeChild(fontInput);
          }
        }

        // **Enable the Note textarea to ensure it is submitted**
        const noteInput = this.form.querySelector(
          'textarea[name="properties[Note]"]'
        );
        if (noteInput) {
          noteInput.disabled = false;
        }

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        if (this.submitButton && !this.error)
          this.submitButton.removeAttribute("disabled");

        this.handleErrorMessage();
        this.submitButton.setAttribute("disabled", "disabled");
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // Create FormData after enabling the Note textarea
        const formData = new FormData(this.form);

        // DEBUG: Log all form data being sent to Shopify
        // const formDataArray = Array.from(formData.entries());
        // console.log('Form data being sent to Shopify:', formDataArray);

        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          if (typeof this.cart.setActiveElement === "function") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("disabled", "disabled");
              this.submitButton.setAttribute("aria-disabled", true);
              if (this.submitButtonText)
                this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton)
              this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (this.submitButton && !this.error) {
              this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.removeAttribute("disabled");
            }
            const spinner = this.querySelector(".loading__spinner");
            if (spinner) spinner.classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text && this.submitButtonText)
            this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          if (this.submitButtonText)
            this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantId100Input() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
